import { Progress } from '@backstage/core-components';
import { Team } from '@internal/schemas-common';
import { useMemo } from 'react';

import {
  getRenovateScore,
  scoreRules,
  useGetMergeRequests,
} from '@internal/backstage-plugin-renovate-stats';
import { HealthScoreCard, SimpleScore } from '@internal/ui-common';

export const RenovateChart = ({
  teams,
  precalculatedScore,
}: {
  teams: Team[];
  boardLabel: string;
  precalculatedScore?: SimpleScore | undefined;
}) => {
  const { value: mrs, loading } = useGetMergeRequests({ teams });
  const score = useMemo(() => {
    if (precalculatedScore) return precalculatedScore;

    if (mrs?.length) {
      return getRenovateScore(mrs);
    }
    return {
      red: 0,
      orange: 0,
      green: 0,
    };
  }, [mrs, precalculatedScore]);

  if (loading) {
    return <Progress />;
  }

  return (
    <HealthScoreCard
      score={score}
      scoreRules={scoreRules}
      trendInfo={{ enabled: false }}
    />
  );
};
